export default __webpack_public_path__ + "static/media/Martiyers9.a1a4c76b.jpg";